﻿import { RelationSaveModel } from "../taskManagement/createTaskPane/CreateTaskPane.types.ts";
import { IncidentDocumentSaveModel } from "./incidentLogOverview/documents/IncidentDocument.types.ts";
import { OverviewTemplateStepInfo } from "@common/hooks/useOverviewTopTab";
import { EvaluationStatus } from "@common/components/questionnaireComponents/evaluateQuestionnaireDialog/EvaluateQuestionnaireDialog.types";
import { IncidentLogStandardField } from "../entityTemplates/EntityTemplate.types";

export interface IncidentLogSaveModel {
    timeOfIncident: Date | null;
    affectedPeopleNotified: boolean | null;
    dateOfAffectedPeopleNotified: Date | null;
    reasonForNotNotifyingAffectedPeople: string | null;
    reasonForNotReportingToAgency: string | null;
    dateOfReportedToAgency: Date | null;
    reportedToAgency: boolean | null;
    measures: string | null;
    consequences: string | null;
    cause: string | null;
    unknownDateOfIncident: boolean;
    dateOfIncident: Date | null;
    name: string;
    entityTemplateId: string | null;
    dataCategories: Array<string>;
    types: Array<string>;
    severity: SeverityLevelEnum | null;
    tags: Array<string>;
    relations: Array<RelationSaveModel>;
    document?: IncidentDocumentSaveModel;
}

export interface IncidentLogListViewModel {
    id: string;
    name: string;
    reportedToAgency: boolean | null;
    affectedPeopleNotified: boolean | null;
    dateAndTimeOfIncident: Date | null;
    hasTime: boolean;
    types: Array<string>;
    dataCategories: Array<string>;
    hasWarning: boolean;
    severity: SeverityLevelEnum | null;
}

export interface IncidentLogEntryOverviewViewModel {
    id: string;
    createdAt: Date;
    name: string;
    userFriendlyId: number;
    template: string;
    status: IncidentLogEntryStatus;
    responsible: string | null;
    discoveryDate: Date | null;
    discoveryTime: Date | null;
    estimatedNumberOfAffectedPeople: number | null;
    isEstimatedNumberOfAffectedPeopleUnknown: boolean;
    reportedToAgencyAnswer: IncidentLogNotificationAnswer | null;
    cause: string | null;
    dateOfIncident: Date | null;
    timeOfIncident: Date | null;
    dataCategories: Array<string>;
    consequences: string | null;
    measures: string | null;
    reportedToAgency: boolean | null;
    dateOfReportedToAgency: Date | null;
    reasonForNotReportingToAgency: string | null;
    affectedPeopleNotified: boolean | null;
    dateOfAffectedPeopleNotified: Date | null;
    reasonForNotNotifyingAffectedPeople: string | null;
    types: Array<string> | null;
    accessRequestType: AccessRequestType | null;
    severity: SeverityLevelEnum | null;
    evaluationStatus?: EvaluationStatus;
    evaluation?: string;
    note?: string;
    entityTemplateId: string;
    templateSteps: Array<OverviewTemplateStepInfo>;
    overviewFields: Array<IncidentLogStandardField>;
    numberOfUsersWithAccess: number;
}

export enum SeverityLevelEnum {
    VeryLow = 1,
    Low = 2,
    Moderate = 3,
    High = 4,
    VeryHigh = 5,
}

export enum AccessRequestType {
    FullAccess = 1,
    CopyOfPersonalData = 2,
    InformationAboutProcessing = 3,
    SpecificInformation = 4,
    TransferToThirdCountries = 5,
    AutomatedDecisionsAndProfiling = 6,
    Other = 7,
    DontKnow = 8,
}

export enum AccessRequestOutcome {
    FullAccess = 1,
    PartialAccess = 2,
    Refused = 3,
    NoPersonalDataFound = 4,
}

export enum ReceiptChannel {
    Email = 1,
    Letter = 2,
    Phone = 3,
    InPerson = 4,
    WebForm = 5,
    Other = 6,
}

export enum IncidentLogEntryStatus {
    Draft = 1,
    Active = 2,
    Archived = 3,
}

export enum IncidentLogNotificationAnswer {
    Yes = 1,
    NotYet = 2,
    NotRequired = 3,
}

export enum YesNoUnknownAnswer {
    Yes = 1,
    No = 2,
    Unknown = 3,
}

export enum InformationSecurityProperty {
    Confidentiality = 1,
    Integrity = 2,
    Availability = 3,
}

export enum YesNoAnswer {
    Yes = 1,
    No = 2,
}

export enum YesNoNotNecessaryAnswer {
    Yes = 1,
    No = 2,
    NotNecessary = 3,
}

export enum IncidentLogPlanTabId {
    Documents = "documents",
    Tasks = "tasks",
    Access = "access",
}

export enum IncidentLogOverviewPaperTabEnum {
    Main = 0,
    AllIncidentLogInfo = 1,
}
